import React from 'react';
import Reveal from '../../../components/shared/Reveal';
import { EditableText } from '../../components';

function CalendarTable({ data, onChange }) {
  const update = (patch) => onChange && onChange({ ...data, ...patch });
  const cols = data.columns || ['Month', 'Highlights'];
  const updateCol = (i, t) => {
    const next = [...cols];
    next[i] = t;
    update({ columns: next });
  };
  const rows = data.rows || [];
  const updateRow = (i, patch) => {
    const next = rows.map((x, idx) => (idx === i ? { ...x, ...patch } : x));
    update({ rows: next });
  };
  return (
    <section className="py-24 bg-olive-light">
      <div className="container-page">
        <Reveal className="max-w-2xl">
          <span className="eyebrow"><span className="h-px w-8 bg-olive" />
            <EditableText value={data.eyebrow} onChange={(t) => update({ eyebrow: t })} as="span" />
          </span>
          <h2 className="section-title mt-4">
            <EditableText value={data.heading} onChange={(t) => update({ heading: t })} as="span" />
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="mt-14 card-surface overflow-hidden">
            <table className="w-full">
              <thead className="bg-olive-deep text-white text-xs uppercase tracking-wider">
                <tr>
                  <th className="text-left px-6 py-4"><EditableText value={cols[0]} onChange={(t) => updateCol(0, t)} as="span" /></th>
                  <th className="text-left px-6 py-4"><EditableText value={cols[1]} onChange={(t) => updateCol(1, t)} as="span" /></th>
                </tr>
              </thead>
              <tbody>
                {rows.map((c, i) => (
                  <tr key={i} className="border-t border-olive/10 hover:bg-olive-light/40">
                    <td className="px-6 py-4 font-semibold text-olive-deep"><EditableText value={c.month} onChange={(t) => updateRow(i, { month: t })} as="span" /></td>
                    <td className="px-6 py-4 text-ink/75"><EditableText value={c.highlight} onChange={(t) => updateRow(i, { highlight: t })} as="span" multiline /></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export default CalendarTable;
